import React from "react";
import Workercard from "../../../../Components/Card/WorkerCard/Workercard.jsx";
import workerData from "../../../../Constant/Constant.jsx";

const Booking = () => {
  return (
    <div className="booking-section ">
      <div className="p-4">
        <h1 className="font-medium"> MY BOOKINGS</h1>
      </div>
      <div className="w-9/12 h-20 border border-black mx-auto">
      </div>

      <div className=" w-full grid grid-cols-3 sm:grid-cols-2 md:grid-cols-2 gap-6 p-5 my-5 ">
        {workerData.map((item, i) => (
          <Workercard key={item.i} {...item} />
        ))}
      </div>
    </div>
  );
};

export default Booking;
